app.controller("changePasswordCtrl", [
  "$scope",
  "decrypt",
  "$ngConfirm",
  "$localStorage",
  "$http",
  "config",
  "ngMeta",
  "checkUser",
  "$location",
  function (
    $scope,
    decrypt,
    $ngConfirm,
    $localStorage,
    $http,
    config,
    ngMeta,
    checkUser,
    $location
  ) {
    ngMeta.setTitle("Change Password");

    checkUser.checkLoginAndVerify(
      () => {},
      () => {
        $location.path("/home");
      }
    );

    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    $scope.customerID = $localStorage.shopUserID;
    $scope.email = $localStorage.email;

    $scope.updatePassword = function (form) {
      $("#updateBtn").attr("disabled", true);
      $("#updateBtnText").html("Please Wait...");

      if ($scope.newPassword !== $scope.confirmP) {
        form.$valid = false;
      }

      if (form.$valid) {
        let postdata = {
          ID: $scope.customerID,
          email: $scope.email,
          old_password: $scope.currentPassword,
          new_password: $scope.newPassword,
        };

        $http({
          method: "POST",
          url: config.fstreamAPI + "UpdatePassword",
          headers: {
            "Content-Type": "application/json", //x-www-form-urlencoded
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function success(response) {
            $("#updateBtn").attr("disabled", false);
            $("#updateBtnText").html("Change Password");
            $localStorage.forcePasswordChange = false;

            $ngConfirm({
              title: "Success",
              content: "Update Complete",
              scope: $scope,
              buttons: {
                close: function (scope, button) {
                  // closes the modal
                },
              },
            });
          },
          function error() {
            $("#updateBtn").attr("disabled", false);
            $("#updateBtnText").html("Change Password");

            if (response.status === 403) {
              $ngConfirm({
                title: "Error",
                content: "Forbidden - Failed to update password",
                scope: $scope,
                buttons: {
                  close: function (scope, button) {
                    // closes the modal
                  },
                },
              });
            } else {
              $("#updateBtn").attr("disabled", false);
              $("#updateBtnText").html("Change Password");
              $ngConfirm({
                title: "Error",
                content: "Failed to update password",
                scope: $scope,
                buttons: {
                  close: function (scope, button) {
                    // closes the modal
                  },
                },
              });
            }
          }
        );
      } else {
        $ngConfirm({
          title: "Error",
          content: "Please complete the form",
          scope: $scope,
          buttons: {
            close: function (scope, button) {
              // closes the modal
            },
          },
        });
        $("#updateBtn").attr("disabled", false);
        $("#updateBtnText").html("Change Password");
      }
    };
  },
]);

app.controller("loginCtrl", [
  "$scope",
  "decrypt",
  "$localStorage",
  "LocalStorageFactory",
  "$http",
  "config",
  "checkUser",
  "$location",
  "ngMeta",
  "cart",
  "getSiteDetails",
  function (
    $scope,
    decrypt,
    $localStorage,
    LocalStorageFactory,
    $http,
    config,
    checkUser,
    $location,
    ngMeta,
    cart,
    getSiteDetails
  ) {
    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    ngMeta.setTitle("Login");

    $scope.email = "";
    $scope.password = "";

    //alert($localStorage.redirectPath)

    $("#loginForm").on("keydown", function (e) {
      var key = e.which;
      switch (key) {
        case 13: // enter
          e.preventDefault()
          login();
          break;
        default:
          break;
      }
    });

    $scope.login = function () {
      login();
    };

    function login() {
      $("#loginBtn").attr("disabled", true);
      $("#loginBtnText").html("Please Wait...");

      $scope.showLoginAlert = false;

      if ($scope.email != "" && $scope.password != "") {
        var postdata = {
          email: $scope.email,
          password: $scope.password,
          siteID: $localStorage.siteID,
        };
        $http({
          withCredentials: true,
          method: "POST",
          url: config.fstreamAPI + "LoginCustomer",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function mySucces(response) {
            $("#loginBtn").attr("disabled", false);
            $("#loginBtnText").html("Sign In");
            LocalStorageFactory.remove("uuid");
            //create a new uuid, set it to localstorage, update remote pool
            let newUuid = checkUser.getUUID($scope);
            checkUser.setBucketUuids(newUuid);
            const userData = response.data.data;
            checkUser.setUser({
              userId: userData.ID,
              name: userData.Name,
              email: $scope.email,
              surname: userData.Surname,
              joined: userData.Joined,
              passwordUpdated: userData.passwordUpdated,
            });
            getSiteDetails.getCustomerContent();

            cart.removeAlreadyOwnedContentFromCart();
            if ($localStorage.redirect !== undefined) {
              let tempPath = $localStorage.redirect;
              LocalStorageFactory.remove("redirect");
              window.location.href = tempPath;
            } else {
              $location.path("/tickets");
            }
          },
          function myError(response) {
            $("#loginBtn").attr("disabled", false);
            $("#loginBtnText").html("Sign In");
            if (response.data.message) {
              $scope.loginAlertText = "Error - " + response.data.message;
            } else {
              $scope.loginAlertText = "Error - Failed to login";
            }

            $scope.showLoginAlert = true;

            if (response.data.data.passwordUpdated === "0") {
              $localStorage.forcePasswordChange = true;
              $location.path("/forgotPassword");
            }
          }
        );
      } else {
        $("#loginBtn").attr("disabled", false);
        $("#loginBtnText").html("Sign In");

        $scope.loginAlertText = "Error: Please enter an email and password.";
        $scope.showLoginAlert = true;
      }
    }
  },
]);

app.controller("logoutCtrl", [
  "$localStorage",
  "$location",
  "checkUser",
  "$rootScope",
  "$route",
  function ($localStorage, $location, checkUser, $rootScope, $route) {
    checkUser.logoutUser();
    $rootScope.accessItems = [];
    $location.path("/");
    $route.reload();
  },
]);

app.controller("forgotPasswordCtrl", [
  "$scope",
  "$http",
  "config",
  "$ngConfirm",
  "$localStorage",
  "ngMeta",
  function ($scope, $http, config, $ngConfirm, $localStorage, ngMeta) {
    ngMeta.setTitle("Forgot Password");

    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    var siteURL = siteConfig.siteURL;

    if ($localStorage.forcePasswordChange === true) {
      $scope.updateMessage =
        "For your security, you will have to update your password when you next log in.";
    }

    $(document).on("keydown", function (e) {
      var key = e.which;
      switch (key) {
        case 13: // enter
          sendEmail();
          break;
        default:
          break;
      }
    });

    $scope.sendEmail = function () {
      sendEmail();
    };

    function sendEmail() {
      $("#updateBtn").attr("disabled", true);
      $("#updateBtnText").html("Please Wait...");

      if ($scope.emailForm.$valid) {
        var postdata = {
          email: $scope.email,
          siteURL: siteURL,
          logo: siteConfig.siteLogoURL,
          shopName: siteConfig.shopTitle,
          siteID: fullSite.siteID,
        };

        $http({
          method: "POST",
          url: config.fstreamAPI + "SetPasswordToken",
          headers: {
            "Content-Type": "application/json", //x-www-form-urlencoded
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function success() {
            $("#updateBtn").attr("disabled", false);
            $("#updateBtnText").html("Send Email");

            $ngConfirm({
              title: "",
              content:
                "<strong>Success</strong> We have sent you an email with further instructions <br> If you don't receive this email make sure you entered the correct email address.",
              scope: $scope,
              buttons: {
                close: function (scope, button) {
                  // closes the modal
                },
              },
            });
          },
          function error() {
            $("#updateBtn").attr("disabled", false);
            $("#updateBtnText").html("Send Email");

            $ngConfirm({
              title: "",
              content:
                "<strong>Success</strong> We have sent you an email with further instructions <br> If you don't receive this email check: <ul><li>You have entered the correct email address</li></ul>",
              scope: $scope,
              buttons: {
                close: function (scope, button) {
                  // closes the modal
                },
              },
            });
          }
        );
      } else {
        $ngConfirm({
          title: "",
          content: "Invalid email format",
          scope: $scope,
          buttons: {
            close: function (scope, button) {
              $("#updateBtn").attr("disabled", false);
              $("#updateBtnText").html("Send Email");
            },
          },
        });
      }
    }
  },
]);

app.controller("resetPasswordCtrl", [
  "$scope",
  "$http",
  "$localStorage",
  "$ngConfirm",
  "$routeParams",
  "decrypt",
  "config",
  "ngMeta",
  "$location",
  function (
    $scope,
    $http,
    $localStorage,
    $ngConfirm,
    $routeParams,
    decrypt,
    config,
    ngMeta,
    $location
  ) {
    ngMeta.setTitle("Reset Password");

    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    let postdata = { token: $routeParams.token };

    $http({
      method: "POST",
      url: config.fstreamAPI + "checkPasswordToken",
      headers: {
        "Content-Type": "application/json", //x-www-form-urlencoded
        Accept: "application/json",
      },
      data: postdata,
    }).then(
      function success() {},
      function error(response) {
        if (response.data.data.message == "expired") {
          $scope.tokenStatus = "expired";
        } else {
          $scope.tokenStatus = "nonexistent";
        }
      }
    );

    $(document).on("keydown", function (e) {
      var key = e.which;
      switch (key) {
        case 13: // enter
          if ($scope.passwordForm) {
            if ($scope.passwordForm.$valid) {
              resetPassword();
            }
          }
          break;
        default:
          break;
      }
    });

    $scope.resetPassword = function () {
      resetPassword();
    };

    function resetPassword() {
      if ($scope.passwordForm.$valid) {
        var postdata = { token: $routeParams.token, password: $scope.password };

        $http({
          method: "POST",
          url: config.fstreamAPI + "UpdatePasswordWithToken",
          headers: {
            "Content-Type": "application/json", //x-www-form-urlencoded
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function success() {
            $localStorage.forcePasswordChange = false;
            $location.path("/home");
            $ngConfirm({
              title: "",
              content:
                "<strong>Success</strong> Update complete<br>You can low login using your new password",
              scope: $scope,
              onClose: function () {
                $location.path("/login");
              },
              buttons: {
                close: function (scope, button) {
                  // closes the modal
                },
              },
            });
          },
          function error(response) {
            if (response.status === 403) {
              $ngConfirm({
                title: "",
                content: "Forbidden - Failed to update password",
                scope: $scope,
                buttons: {
                  close: function (scope, button) {
                    // closes the modal
                  },
                },
              });
            } else {
              $ngConfirm({
                title: "",
                content: "error",
                scope: $scope,
                buttons: {
                  close: function (scope, button) {
                    // closes the modal
                  },
                },
              });
            }
          }
        );
      } else {
        toastr.error("Please complete the form");
      }
    }
  },
]);

app.controller("loginItemCtrl", [
  "$scope",
  "decrypt",
  "$localStorage",
  "$http",
  "config",
  "checkUser",
  "$location",
  "ngMeta",
  "$routeParams",
  "cart",
  "getSiteDetails",
  function (
    $scope,
    decrypt,
    $localStorage,
    $http,
    config,
    checkUser,
    $location,
    ngMeta,
    $routeParams,
    cart,
    getSiteDetails
  ) {
    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    ngMeta.setTitle("Login");

    $scope.email = "";
    $scope.password = "";

    //alert($localStorage.redirectPath)

    $(document).on("keydown", function (e) {
      var key = e.which;
      switch (key) {
        case 13: // enter
          login();
          break;
        default:
          break;
      }
    });

    $scope.login = function () {
      login();
    };

    function login() {
      $("#loginBtn").attr("disabled", true);
      $("#loginBtnText").html("Please Wait...");

      $scope.showLoginAlert = false;

      if ($scope.email != "" && $scope.password != "") {
        var postdata = {
          email: $scope.email,
          password: $scope.password,
          siteID: $localStorage.siteID,
        };

        $http({
          withCredentials: true,
          method: "POST",
          url: config.fstreamAPI + "LoginCustomer",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function mySucces(response) {
            $("#loginBtn").attr("disabled", false);
            $("#loginBtnText").html("Sign In");

            $localStorage.uuid = checkUser.getUUID();
            checkUser.setBucketUuids();
            const userData = response.data.data;

            checkUser.setUser({
              userId: userData.ID,
              name: userData.Name,
              email: $scope.email,
              surname: userData.Surname,
              joined: userData.Joined,
              passwordUpdated: userData.passwordUpdated,
            });

            getSiteDetails.getCustomerContent();
            cart.removeAlreadyOwnedContentFromCart();
            $location.path(`/item/${$routeParams.contentID}`);
          },
          function myError(response) {
            $("#loginBtn").attr("disabled", false);
            $("#loginBtnText").html("Sign In");

            $scope.loginAlertText = "Error - " + response.data.message;
            $scope.showLoginAlert = true;

            if (response.data.data.passwordUpdated === "0") {
              $localStorage.forcePasswordChange = true;
              $location.path("/forgotPassword");
            }
          }
        );
      } else {
        $("#loginBtn").attr("disabled", false);
        $("#loginBtnText").html("Sign In");

        $scope.loginAlertText = "Error: Please enter an email and password.";
        $scope.showLoginAlert = true;
      }
    }
  },
]);
